/**
 * Flows, api-core's workflow builder. talk2 shows it only when the company has flows_enabled.
 */

export const FLOW_PERMISSIONS = {
  LIST: 'list workflow',
  UPDATE: 'update workflow',
  UPDATE_CONTACT: 'update contact'
}

export const FLOW_ENROLLMENT_STATUSES = {
  active: { label: 'Running', variant: 'success' },
  completed: { label: 'Finished', variant: 'secondary' },
  exited: { label: 'Ended early', variant: 'secondary' },
  failed: { label: 'Failed', variant: 'danger' }
}

// why a run stopped early, in the words api-core's admin run panel uses (flow-definition.js EXIT_REASONS)
export const FLOW_EXIT_REASONS = {
  exited_by_user: 'Exited by an agent',
  exited_by_api: 'Removed through the API',
  exited_by_hubspot: 'Removed by a HubSpot workflow',
  exited_by_mcp: 'Removed through MCP',
  exited_by_aloai: 'Removed by an AloAi agent',
  manual: 'Exited by support',
  contact_deleted: 'The contact was deleted',
  contact_dnc: 'The contact is DNC',
  contact_opted_out: 'The contact opted out of texts',
  flow_archived: 'The flow was archived',
  flow_deleted: 'The flow was deleted',
  company_disabled: 'The account is disabled',
  flows_disabled: 'Flows was turned off for the account',
  wait_date_passed: 'A wait date had already passed',
  wait_no_appointment: 'The contact had no upcoming appointment',
  hourly_message_limit: 'The contact stayed at the hourly text limit',
  line_inactive: 'The line stayed inactive',
  low_credits: 'The account stayed low on credits',
  engine_start_failed: 'The run could not start',
  engine_error: 'Something went wrong in the run',
  run_failed: 'Something went wrong in the run',
  debug_exit: 'A debug step ended the run',
  test_replaced_by_enrollment: 'A real enrollment replaced this test',
  trigger_exit: 'A trigger ended the run',
  contact_replied: 'The contact replied',
  call_answered: 'The contact talked with someone on a call'
}

export const FLOW_ENROLLMENT_ACTIVE = 'active'
export const FLOW_ENROLLMENT_EXITED = 'exited'
export const FLOW_ENROLLMENT_FAILED = 'failed'

// the most runs api-core sends for one contact, active ones first (FlowContactEnrollmentController::LIMIT)
export const FLOW_CONTACT_RUNS_LIMIT = 50

export const FLOW_BULK_SOURCES = {
  TAG: 'tag',
  LIST: 'list'
}

export const FLOW_BULK_MODES = {
  NOW: 'now',
  SCHEDULED: 'scheduled',
  DRIP: 'drip'
}

export const FLOW_BULK_MODE_CHOICES = [
  { value: FLOW_BULK_MODES.NOW, label: 'Now' },
  { value: FLOW_BULK_MODES.SCHEDULED, label: 'At a set time' },
  { value: FLOW_BULK_MODES.DRIP, label: 'In batches' }
]

export const FLOW_INTERVAL_UNITS = [
  { value: 'minutes', label: 'Minutes' },
  { value: 'hours', label: 'Hours' },
  { value: 'days', label: 'Days' }
]

export const FLOW_MAX_BATCH_SIZE = 10000

// A flow's status, as GET flows/filterable returns it
export const FLOW_STATUS_ACTIVE = 'active'
export const FLOW_STATUS_PAUSED = 'paused'
export const FLOW_STATUS_ARCHIVED = 'archived'

// The groups of the flow filter on past communications, in order
export const FLOW_FILTER_GROUPS = [
  { status: FLOW_STATUS_ACTIVE, label: 'Active' },
  { status: FLOW_STATUS_PAUSED, label: 'Paused' },
  { status: FLOW_STATUS_ARCHIVED, label: 'Archived' }
]
